"use client";

import { useEffect, useState } from "react";

export function useLiveReferenceTime(refreshIntervalMs = 60_000): Date | null {
  const [referenceTime, setReferenceTime] = useState<Date | null>(null);

  useEffect(() => {
    const refresh = () => setReferenceTime(new Date());
    refresh();
    const intervalId = window.setInterval(refresh, refreshIntervalMs);
    return () => window.clearInterval(intervalId);
  }, [refreshIntervalMs]);

  return referenceTime;
}
